import { render, staticRenderFns } from "./PmcForm.vue?vue&type=template&id=50fc082e&scoped=true"
import script from "./PmcForm.vue?vue&type=script&lang=js"
export * from "./PmcForm.vue?vue&type=script&lang=js"
import style0 from "./PmcForm.vue?vue&type=style&index=0&id=50fc082e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc082e",
  null
  
)

export default component.exports